import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import getMarkDownComponents, { MarkdownBaseTypographyVariant } from './MarkDownComponents'
import { Box } from '@mui/material'
import { useMemo } from 'react'
import { NormalComponents, SpecialComponents } from 'react-markdown/src/ast-to-react'
import DOMPurify from 'dompurify'

function MarkDownPreviewMode({
  content,
  baseTypographyVariant = 'body2',
  overrideComponents
}: {
  content: string | undefined
  baseTypographyVariant?: MarkdownBaseTypographyVariant
  overrideComponents?: Partial<Omit<NormalComponents, keyof SpecialComponents> & SpecialComponents>
}) {
  const defaultMarkdownComponents = useMemo(
    () => getMarkDownComponents({ baseTypographyVariant }),
    [baseTypographyVariant]
  )
  const components: Partial<Omit<NormalComponents, keyof SpecialComponents> & SpecialComponents> = {
    ...defaultMarkdownComponents,
    ...overrideComponents
  }
  return (
    <Box>
      <ReactMarkdown
        skipHtml={false}
        linkTarget="_blank"
        rehypePlugins={[rehypeRaw]}
        children={DOMPurify.sanitize(content || '')}
        components={components}
      />
    </Box>
  )
}

export default MarkDownPreviewMode
